module.exports = __webpack_public_path__ + "img/ico-survey-begin.b5c4ea70.svg";